/**
 * Module Registry (portal edition — metadata only).
 *
 * The portal only needs module METADATA for the signup wizard
 * (Step2ModuleSelection). The real loadable modules live in the LeaRes
 * webapp (WERESP_WEB); here `load` resolves to an empty module so nothing
 * from the viewer stack gets bundled into the portal.
 */

export const moduleRegistry = {
  segmentation: {
    id: 'segmentation',
    name: 'Segment and Reconstruct',
    description: 'Segment, edit and reconstruct 3D models from CT/MRI scans',
    load: () => Promise.resolve({}),
    menuItems: ['Segment and Reconstruct'],
    requiredPermission: 'segmentation',
    icon: 'SegmentIcon',
    dataAccess: 'patients',
    scope: 'medical',
  },
  engineering: {
    id: 'engineering',
    name: 'Simulate Devices',
    description: 'Simulate flows and biomechanics in complex domains',
    load: () => Promise.resolve({}),
    menuItems: [
      'Simulation Types',
      'CAD Import',
      'Zoning',
      'Materials',
      'Boundaries',
      'Conditions',
      'Simulate',
      'Result',
    ],
    requiredPermission: 'engineering',
    icon: 'EngineeringIcon',
    dataAccess: 'projects',
    scope: 'engineering',
  },
  respirology: {
    id: 'respirology',
    name: 'Respirology',
    description: 'Pulmonary diagnostics and analysis',
    load: () => Promise.resolve({}),
    menuItems: ['Diagnostics'],
    requiredPermission: 'respirology',
    icon: 'DiagnosticsIcon',
    dataAccess: 'patients',
    scope: 'medical',
  },
  vascular: {
    id: 'vascular',
    name: 'Vascular',
    description: 'Coronary plaque analysis and vascular morphology (RUO)',
    load: () => Promise.resolve({}),
    menuItems: ['Diagnostics'],
    requiredPermission: 'vascular',
    icon: 'DiagnosticsIcon',
    dataAccess: 'patients',
    scope: 'medical',
  },
}

export const getModuleMetadata = (moduleId) => {
  const module = moduleRegistry[moduleId]
  if (!module) return null

  const { load, ...metadata } = module
  return metadata
}

export const getAllModules = () => {
  return Object.keys(moduleRegistry).map(getModuleMetadata)
}

/**
 * Moduli che un utente puo' chiedere per se' in fase di REGISTRAZIONE.
 *
 * Deve restare uguale a SELF_SIGNUP_MODULES del backend
 * (DIGISCAN_WEB/models/Auth.py), che e' di proposito piu' stretto del catalogo:
 * tutto il resto lo concede solo un admin, o lo si compra dal carrello
 * moduli, altrimenti il signup self-service diventerebbe una scalata di
 * privilegi. Un modulo offerto qui ma assente la' fa rispondere 400 "Invalid
 * module" al signup: chi lo spunta non riesce a registrarsi (ticket
 * 6aad9f72…140c). `respirology` e' uscito da qui il 2026-09-23: e' diventato
 * acquistabile dal carrello, quindi un nuovo utente non lo riceve piu' gratis
 * al self-signup.
 */
export const SELF_SIGNUP_MODULE_IDS = ['segmentation', 'engineering']

export const getSelfSignupModules = () =>
  SELF_SIGNUP_MODULE_IDS.map(getModuleMetadata).filter(Boolean)
